var React = require('react');

function Marketing (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.33333 33.3167L15.8333 20.8L22.5 27.4667L34.3167 14.1833L36.6667 16.5333L22.5 32.4667L15.8333 25.8L5.83333 35.8167L3.33333 33.3167ZM5.83333 25.8167L15.8333 15.8L22.5 22.4667L36.6667 6.53335L34.3167 4.18335L22.5 17.4667L15.8333 10.8L3.33333 23.3167L5.83333 25.8167Z"}));
}

Marketing.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Marketing;

Marketing.default = Marketing;
